import type { ReactNode } from 'react'
import React from 'react'

import { Toasts, Tooltip, useCopyToClipboard } from '@fourthwall/components'
import { TickIcon } from '@fourthwall/icons'

type Props = {
  text: string
  tooltipText?: string
  copiedTooltipText?: string
  children: ReactNode
}

export const CopyableText = ({
  text,
  tooltipText = 'Copy to clipboard',
  copiedTooltipText = 'Value copied to clipboard',
  children,
}: Props) => {
  const { isCopied, copyToClipboard } = useCopyToClipboard()

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      copyToClipboard(text)
      Toasts.notify(copiedTooltipText, { type: 'info' })
    }
  }

  const renderTooltip = () => {
    if (isCopied) {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <TickIcon />
          &nbsp;{copiedTooltipText}
        </div>
      )
    }

    return tooltipText
  }

  return (
    <div role="button" tabIndex={0} onKeyDown={handleKeyDown} onClick={() => copyToClipboard(text)}>
      <Tooltip reference={children} placement="top" fluid>
        {renderTooltip()}
      </Tooltip>
    </div>
  )
}
